// Libs
import clsx from "clsx";
import type React from "react";

// Components

export interface TooltipTitleProps extends React.PropsWithChildren<unknown> {
    /**
     * Additional className
     */
    className?: string;
    /**
     * Typography className
     */
    typographyClassName?: string;
    /**
     * Start adornment
     */
    startAdornment?: JSX.Element;
}

export function TooltipTitle({
    children,
    className: classNameProp,
    startAdornment,
    typographyClassName = "ds-u-typography--subtitle-medium",
}: TooltipTitleProps): JSX.Element {
    const className = clsx("ds-c-tooltip__title", typographyClassName, classNameProp);

    return (
        <div className={className}>
            {startAdornment}
            {children}
        </div>
    );
}
